export function clearUrl(url: string) {
  if (url) {
    try {
      return new URL(url).origin
    } catch {
      return ''
    }
  }

  return ''
}
